var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFinancialRFocus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "245px",
    viewBox: "0 0 241 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_FinancialR_focus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_FinancialR_focus",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_Over",
    transform: "translate(0.500000, 0.000000)",
    fill: "#1A4480",
    fillRule: "nonzero",
    stroke: "#A48923",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.4771525,0 0,4.4771525 0,10 L0,170 C0,175.522847 4.4771525,180 10,180 L218,180 C223.522847,180 228,175.522847 228,170 L228,10 C228,4.4771525 223.522847,0 218,0 L10,0 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(138.000000, 46.000000)",
    fill: "#1A4480",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.38775373,
    y: 6.38775373,
    width: 67.0714141,
    height: 83.8392676
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 3.19387686,
    y: 3.19387686,
    width: 67.0714141,
    height: 83.8392676
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0,
    y: 0,
    width: 67.0714141,
    height: 83.8392676
  })), /*#__PURE__*/React.createElement("g", {
    id: "$-copy",
    transform: "translate(162.500000, 43.000000)",
    fill: "#D9E8F6",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 30,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    id: "$"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.80193,
    y: 30
  }, "$"))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    transform: "translate(145.000000, 79.000000)",
    fill: "#D9E8F6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 12,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 0,
    y: 24,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 0,
    y: 36,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 29,
    y: 0,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 29,
    y: 12,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 29,
    y: 24,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 29,
    y: 36,
    width: 23,
    height: 8
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#A48923",
    fillRule: "nonzero",
    x: 109.5,
    y: 86.678569,
    width: 21,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-Copy",
    fill: "#A48923",
    fillRule: "nonzero",
    transform: "translate(132.458653, 90.178569) rotate(90.000000) translate(-132.458653, -90.178569) ",
    points: "132.458653 78.678569 143.637222 101.678569 132.458653 97.678569 121.280084 101.678569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5974396,67.6761346 L16.5974396,72.4011936 C16.5790907,72.8482533 17.0668273,73.2219206 17.6887031,73.2372378 L107.329134,73.2372378 C107.951009,73.2219206 108.438746,72.8482533 108.420397,72.4011936 L108.420397,67.6761346 C108.431464,67.232697 107.945796,66.8647946 107.329134,66.8494841 L17.6821685,66.8494841 C17.0680846,66.8672856 16.5862826,67.234457 16.5974396,67.6761346 L16.5974396,67.6761346 Z",
    id: "Path-Copy-11",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.194263,127.91164 L18.194263,123.960772 C18.1889396,123.852621 18.2388349,123.747302 18.3327876,123.668372 C18.4267397,123.589444 18.5569091,123.543492 18.694176,123.540798 L106.323661,123.540798 C106.460928,123.543492 106.591097,123.589444 106.685049,123.668372 C106.779002,123.747302 106.828897,123.852621 106.823573,123.960772 L106.823573,127.91164 C106.828897,128.019791 106.779002,128.12511 106.685049,128.20404 C106.591097,128.282969 106.460928,128.32892 106.323661,128.331614 L18.694176,128.331614 C18.5569091,128.32892 18.4267397,128.282969 18.3327876,128.20404 C18.2388349,128.12511 18.1889396,128.019791 18.194263,127.91164 Z",
    id: "Path-Copy-10",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1407286,76.9884731 C46.1372556,76.8447997 46.1808659,76.7053382 46.261956,76.6007997 C46.3430455,76.4962612 46.4549654,76.4352188 46.5730683,76.4311147 L54.4906919,76.4311147 C54.6087948,76.4352188 54.7207147,76.4962612 54.8018042,76.6007997 C54.8828943,76.7053382 54.9265045,76.8447997 54.9230316,76.9884731 L54.9230316,81.4551906 C54.9282661,81.6001965 54.8854432,81.7416914 54.8041653,81.847948 C54.7228874,81.9542045 54.6099551,82.0163318 54.4906919,82.0203992 L46.5730683,82.0203992 C46.4538051,82.0163318 46.3408728,81.9542045 46.2595949,81.847948 C46.178317,81.7416914 46.1354941,81.6001965 46.1407286,81.4551906 L46.1407286,76.9884731 Z",
    id: "Path-Copy-9",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9851723,81.4551906 L22.9851723,76.9884731 C22.9816994,76.8447997 23.0253092,76.7053382 23.1063988,76.6007997 C23.1874878,76.4962612 23.2994069,76.4352188 23.4175089,76.4311147 L31.3415305,76.4311147 C31.5849257,76.443868 31.7747014,76.6922294 31.7674144,76.9884731 L31.7674144,81.4551906 C31.7726618,81.598883 31.7307147,81.7392141 31.6508229,81.8452421 C31.5709309,81.95127 31.4596552,82.0142873 31.3415305,82.0203992 L23.3981506,82.0203992 C23.1572746,81.9994218 22.9740561,81.7486662 22.9851723,81.4551906 L22.9851723,81.4551906 Z",
    id: "Path-Copy-8",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001661,137.3118 L15.0001661,132.126935 C14.9927717,131.804987 15.2332192,131.536763 15.5393273,131.525491 L109.484886,131.525491 C109.631399,131.530894 109.769859,131.597321 109.869758,131.710135 C109.969657,131.822951 110.022798,131.972896 110.017472,132.126935 L110.017472,137.3118 C110.022798,137.465839 109.969657,137.615784 109.869758,137.7286 C109.769859,137.841414 109.631399,137.907841 109.484886,137.913244 L15.5393273,137.913244 C15.2332192,137.901972 14.9927717,137.633748 15.0001661,137.3118 Z",
    id: "Path-Copy-7",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2504223,81.4551906 L93.2504223,76.9884731 C93.2431351,76.6922294 93.432912,76.443868 93.6763087,76.4311147 L101.600376,76.4311147 C101.718479,76.4352188 101.830399,76.4962612 101.911488,76.6007997 C101.992578,76.7053382 102.036188,76.8447997 102.032715,76.9884731 L102.032715,81.4551906 C102.03795,81.6001965 101.995127,81.7416914 101.913849,81.847948 C101.832571,81.9542045 101.719639,82.0163318 101.600376,82.0203992 L93.6763087,82.0203992 C93.5581833,82.0142873 93.446907,81.95127 93.3670145,81.8452421 C93.2871221,81.7392141 93.2451749,81.598883 93.2504223,81.4551906 L93.2504223,81.4551906 Z",
    id: "Path-Copy-6",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2963358,81.4551906 L69.2963358,76.9884731 C69.2928629,76.8447997 69.3364731,76.7053382 69.4175631,76.6007997 C69.4986525,76.4962612 69.6105722,76.4352188 69.7286751,76.4311147 L77.6527425,76.4311147 C77.7702955,76.4351807 77.8815867,76.4964808 77.9616547,76.6012657 C78.0417226,76.7060506 78.0838647,76.8455495 78.0786289,76.9884731 L78.0786289,81.4551906 C78.0838763,81.598883 78.0419291,81.7392141 77.9620366,81.8452421 C77.8821442,81.95127 77.7708679,82.0142873 77.6527425,82.0203992 L69.7286751,82.0203992 C69.609412,82.0163318 69.4964798,81.9542045 69.415202,81.847948 C69.3339242,81.7416914 69.2911013,81.6001965 69.2963358,81.4551906 L69.2963358,81.4551906 Z",
    id: "Path-Copy-5",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5816306,120.098752 L24.5816306,84.6639767 C24.7199753,84.4448545 24.8660432,84.3696428 25.0105905,84.443101 L29.7419552,84.443101 C29.8865024,84.3696428 30.0325704,84.4448545 30.1709151,84.6639767 L30.1709151,120.098752 C30.0325704,120.317874 29.8865024,120.393085 29.7419552,120.319628 L25.0105905,120.319628 C24.8660432,120.393085 24.7199753,120.317874 24.5816306,120.098752 L24.5816306,120.098752 Z",
    id: "Path-Copy-4",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7372378,120.098752 L47.7372378,84.6639767 C47.8754243,84.4448545 48.021325,84.3696428 48.165707,84.443101 L52.8980532,84.443101 C53.0424352,84.3696428 53.1883359,84.4448545 53.3265224,84.6639767 L53.3265224,120.098752 C53.1883359,120.317874 53.0424352,120.393085 52.8980532,120.319628 L48.165707,120.319628 C48.021325,120.393085 47.8754243,120.317874 47.7372378,120.098752 L47.7372378,120.098752 Z",
    id: "Path-Copy-3",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.846922,120.097566 L94.846922,84.6651627 C94.983289,84.4477147 95.127364,84.3724965 95.269964,84.4443018 L100.013164,84.4443018 C100.155765,84.3686854 100.300001,84.4439882 100.436206,84.6651627 L100.436206,120.097566 C100.300001,120.318739 100.155765,120.394043 100.013164,120.318427 L95.250735,120.318427 C95.114487,120.377255 94.977222,120.302181 94.846922,120.097566 L94.846922,120.097566 Z",
    id: "Path-Copy-2",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8928451,120.098752 L70.8928451,84.6639767 C71.0311898,84.4448545 71.1772578,84.3696428 71.321805,84.443101 L76.0531697,84.443101 C76.1977169,84.3696428 76.3437849,84.4448545 76.4821296,84.6639767 L76.4821296,120.098752 C76.3437849,120.317874 76.1977169,120.393085 76.0531697,120.319628 L71.321805,120.319628 C71.1772578,120.393085 71.0311898,120.317874 70.8928451,120.098752 L70.8928451,120.098752 Z",
    id: "Path-Copy",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3394144,40.5489101 L25.5172178,63.1102466 C25.4054522,63.184063 25.3555285,63.3129107 25.3917685,63.4340195 C25.4280084,63.5551284 25.5428739,63.6433107 25.6804078,63.6556073 L99.324801,63.6556073 C99.466984,63.6502745 99.588975,63.5618982 99.626292,63.4371908 C99.663608,63.3124832 99.607648,63.1801942 99.487991,63.1102466 L62.6657945,40.5489101 C62.5688511,40.4836966 62.4363578,40.4836966 62.3394144,40.5489101 Z M63.1096713,57.0994228 L63.1096713,58.4628246 L61.7454027,58.4628246 L61.7454027,57.1824125 C60.9193244,57.1569586 60.1116977,56.9537951 59.3889388,56.5896291 L59.8001777,55.0128252 C60.4997146,55.3913376 61.2967216,55.5957944 62.1109484,55.6056086 C62.9007881,55.6056086 63.4164686,55.3092169 63.4164686,54.769784 C63.4164686,54.2303511 62.9725917,53.9398873 61.9412308,53.5842172 C60.4594654,53.0981348 59.4411596,52.3986504 59.4411596,51.1241661 C59.4637758,49.9122214 60.4662763,48.9006778 61.7910959,48.7530324 L61.7910959,47.4904038 L63.148837,47.4904038 L63.148837,48.6759706 C63.8488751,48.6885476 64.5373712,48.8403038 65.1658656,49.1205581 L64.7611544,50.6380837 C64.1450305,50.3432651 63.4601082,50.1867511 62.7637085,50.1816405 C61.8628996,50.1816405 61.5691575,50.5610218 61.5691575,50.9344754 C61.5691575,51.307929 62.0522,51.6635989 63.2336958,52.090403 C64.8851788,52.6831864 65.5509941,53.4004543 65.5509941,54.6097325 C65.5504895,55.8818584 64.5010778,56.9520607 63.1096713,57.0994228 Z",
    id: "Shape-Copy",
    fill: "#5F7CA6",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFinancialRFocus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_FinancialR_focus.755f331b1cc6d73efac914f4aa0563fa.svg";